import PathWrapper from "core/PathWrapper";

export default new PathWrapper("/checkout-ap");